import { ConfigConstants } from '../config_constants';
import { INumberFormatter } from '../../../utils/number-formatter/i-number-formatter';

export class ResourcesConfiguration {
  static fromJson(
    json: Record<string, any>,
    _numberFormatter?: INumberFormatter
  ): ResourcesConfiguration {
    const config = new ResourcesConfiguration();
    config.sceneName = json[ConfigConstants.sceneName];
    config.name = json[ConfigConstants.resourceName];
    return config;
  }

  public sceneName: string;
  public name: string;
}
